import { useQuery } from "@tanstack/react-query";
import { useSession } from "next-auth/react";
import useSWR from "swr";
import { fetcher } from "./fetcher";

//  종목 디테일 뉴스레이더
export const useStockNewsRader = (ticker: string) => {
    const { data, isLoading, isError } = useQuery({
        queryKey: ["newsrader", ticker],
        queryFn: async () => {
            const res = await fetch(`/api/detail/newsrader?ticker=${ticker}`)
            const data = await res.json();
            return data;
        },
        staleTime: 1000 * 60,
        enabled: ticker !== undefined,
    })
    return { data, isLoading, isError };
}


// 홈 뉴스레이더
export const useHomeNewsRader = () => {
    const { data, isLoading, isError } = useQuery({
        queryKey: ["newsRader", "home"],
        queryFn: async () => {
            const res = await fetch(`/api/newsrader`)
            const data = await res.json();
            return data;
        },
    })
    return { data, isLoading, isError };
}

// 관심 뉴스레이더 — 세션/관심종목 준비 후 POST (빈 배열 조기 캐시 방지)
export const useInterestNewsRader = () => {
    const { data: session } = useSession();
    const { data: userInfo } = useSWR(
        session?.user?.email
            ? `/api/auth/user?session=${session.user.email}`
            : null,
        fetcher,
        { revalidateOnFocus: false }
    );
    const interest = userInfo?.user?.interest;
    const interestKey = Array.isArray(interest)
        ? interest.map((i: any) => i?.ticker).filter(Boolean).join(",")
        : "";

    const { data, isLoading, isError } = useQuery({
        queryKey: ["newsRader", "interest", interestKey],
        queryFn: async () => {
            const res = await fetch(`/api/newsrader/interest`, {
                method: "POST",
                headers: { "content-type": "application/json" },
                body: JSON.stringify({ interest }),
            });
            const data = await res.json();
            return Array.isArray(data) ? data : [];
        },
        enabled: Boolean(session?.user?.email && interestKey),
        staleTime: 1000 * 60,
    });
    return { data, isLoading, isError };
}